module.exports = __webpack_public_path__ + "07_hige_gray.a9e40eb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer3/07_hige_gray.png
// module id = tMQJ
// module chunks = 0